import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaArrowLeft, FaPlay, FaEdit } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { fetchDataApi } from 'src/services/dataSourceServices';

// Updated dummy data with new asset fields - same as in new_demo_frontend
const dummyDataSources: any[] = [
  {
    id: "DS001",
    dataSourceName: "AWS EC2 Instances",
    assetType: "Server",
    integrationMethod: "API Pull",
    updateFrequency: "Daily",
    clientId: "AWS_CLIENT_001",
    description: "Pull EC2 instance data from AWS API to track cloud server assets",
    status: "Active",
    lastRun: "2024-01-15 10:30:00",
    assetsCount: 25,
    createdAt: "2024-01-01T10:00:00Z",
    apiEndpoint: "https://ec2.us-east-1.amazonaws.com/",
    apiMethod: "GET",
    apiAuthentication: "AWS Signature v4",
    sampleAssets: [
      {
        id: "UAM-01",
        name: "Web Server Prod 01",
        type: "Server",
        owner: "IT Admin",
        custodian: "DevOps Team",
        posture: "Acceptable",
        date: "01/07/2024"
      },
      {
        id: "PMP-02",
        name: "Database Server Prod 01",
        type: "Server",
        owner: "IT Admin",
        custodian: "DBA Team",
        posture: "Risky",
        date: "15/07/2024"
      },
      {
        id: "UAM-03",
        name: "App Server Staging 01",
        type: "Server",
        owner: "Development Team",
        custodian: "DevOps Team",
        posture: "Average",
        date: "01/09/2024"
      }
    ]
  },
  {
    id: "DS002",
    dataSourceName: "Oracle Database Servers",
    assetType: "Server",
    integrationMethod: "Database",
    updateFrequency: "Weekly",
    clientId: "ORACLE_CLIENT_002",
    description: "Direct database connection to Oracle CMDB to extract database server information",
    status: "Active",
    lastRun: "2024-01-14 15:45:00",
    assetsCount: 12,
    createdAt: "2024-01-02T14:30:00Z",
    dbConnectionString: "jdbc:oracle:thin:@//cmdb.company.com:1521/CMDB",
    dbUsername: "cmdb_readonly",
    dbPassword: "secure_password_123",
    sampleAssets: [
      {
        id: "UAM-04",
        name: "Oracle Prod Database",
        type: "Server",
        owner: "IT Operations",
        custodian: "DBA Team",
        posture: "Acceptable",
        date: "15/06/2024"
      },
      {
        id: "PMP-05",
        name: "Oracle Test Database",
        type: "Server",
        owner: "Development Team",
        custodian: "DBA Team",
        posture: "Average",
        date: "01/08/2024"
      },
      {
        id: "UAM-06",
        name: "Oracle Dev Database",
        type: "Server",
        owner: "Development Team",
        custodian: "DBA Team",
        posture: "Risky",
        date: "01/07/2024"
      }
    ]
  },
  {
    id: "DS003",
    dataSourceName: "Network Devices Inventory",
    assetType: "Network Equipment",
    integrationMethod: "File",
    updateFrequency: "Monthly",
    clientId: "NETWORK_CLIENT_003",
    description: "Import network device inventory from CSV file exported from network management system",
    status: "Active",
    lastRun: "2024-01-10 09:15:00",
    assetsCount: 45,
    createdAt: "2024-01-03T09:15:00Z",
    filePath: "/data/exports/network_devices.csv",
    fileFormat: "CSV",
    sampleAssets: [
      {
        id: "UAM-07",
        name: "Core Switch 01",
        type: "Network Equipment",
        owner: "Network Operations",
        custodian: "Network Admin",
        posture: "Acceptable",
        date: "01/07/2024"
      },
      {
        id: "PMP-08",
        name: "Edge Router 01",
        type: "Network Equipment",
        owner: "Network Operations",
        custodian: "Network Admin",
        posture: "Acceptable",
        date: "15/07/2024"
      },
      {
        id: "UAM-09",
        name: "WiFi AP Floor 1",
        type: "Network Equipment",
        owner: "IT Support",
        custodian: "Network Admin",
        posture: "Average",
        date: "01/09/2024"
      }
    ]
  },
  {
    id: "DS004",
    dataSourceName: "Active Directory Users",
    assetType: "People",
    integrationMethod: "LDAP/Active Directory",
    updateFrequency: "Daily",
    clientId: "AD_CLIENT_004",
    description: "Extract user endpoint information from Active Directory for asset tracking",
    status: "Active",
    lastRun: "2024-01-15 08:00:00",
    assetsCount: 150,
    createdAt: "2024-01-04T11:45:00Z",
    ldapServer: "ldap.company.com",
    ldapPort: "389",
    ldapBaseDN: "dc=company,dc=com",
    sampleAssets: [
      {
        id: "UAM-10",
        name: "John Doe",
        type: "People",
        owner: "IT Department",
        custodian: "HR Admin",
        posture: "Acceptable",
        date: "15/06/2024"
      },
      {
        id: "PMP-11",
        name: "Jane Smith",
        type: "People",
        owner: "Marketing Department",
        custodian: "HR Admin",
        posture: "Acceptable",
        date: "01/08/2024"
      },
      {
        id: "UAM-12",
        name: "Mike Wilson",
        type: "People",
        owner: "Sales Department",
        custodian: "HR Admin",
        posture: "Risky",
        date: "01/07/2024"
      }
    ]
  },
  {
    id: "DS005",
    dataSourceName: "FTP Server Files",
    assetType: "Data/Info",
    integrationMethod: "FTP",
    updateFrequency: "Weekly",
    clientId: "FTP_CLIENT_005",
    description: "Monitor application files and assets stored on FTP server",
    status: "Active",
    lastRun: "2024-01-13 14:20:00",
    assetsCount: 78,
    createdAt: "2024-01-05T16:20:00Z",
    ftpServer: "ftp.company.com",
    ftpPort: "21",
    sampleAssets: [
      {
        id: "UAM-13",
        name: "Web Application Files",
        type: "Data/Info",
        owner: "IT Admin",
        custodian: "IT Admin",
        posture: "Acceptable",
        date: "01/07/2024"
      },
      {
        id: "PMP-14",
        name: "Database Schema Files",
        type: "Data/Info",
        owner: "Development Team",
        custodian: "DBA Team",
        posture: "Risky",
        date: "15/07/2024"
      },
      {
        id: "UAM-15",
        name: "Configuration Files",
        type: "Data/Info",
        owner: "IT Admin",
        custodian: "IT Admin",
        posture: "Average",
        date: "01/09/2024"
      }
    ]
  }
];

const DataSourceDetails: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [loading, setLoading] = useState(true);
  const [dataSource, setDataSource] = useState<any>(null);
  const [useDummyData] = useState<boolean>(true);

  useEffect(() => {
    loadDataSource();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const loadDataSource = async () => {
    setLoading(true);
    try {
      if (useDummyData) {
        const data = dummyDataSources.find(ds => ds.id === id);
        if (!data) {
          toast.error(t('dataResource.details.toast.notFound', { defaultValue: 'Data source not found' }));
          navigate('/dataresource');
          return;
        }
        setDataSource(data);
      } else {
        const result = await fetchDataApi(`data-sources/${id}`);
        if (!result.success || !result.data) {
          toast.error(t('dataResource.details.toast.notFound', { defaultValue: 'Data source not found' }));
          navigate('/dataresource');
          return;
        }
        setDataSource(result.data);
      }
    } catch (error: any) {
      toast.error(error.message || t('dataResource.details.toast.fetchFailed', { defaultValue: 'Failed to fetch data source' }));
      navigate('/dataresource');
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate('/dataresource');
  };

  const handleEdit = () => {
    navigate(`/dataresource/update/${id}`);
  };

  const handleRun = async () => {
    if (!dataSource) return;
    try {
      toast.info(t('dataResource.details.toast.running', { name: dataSource.dataSourceName, defaultValue: `Running ${dataSource.dataSourceName}...` }));
      await new Promise(resolve => setTimeout(resolve, 2000));
      const newAssetsCount = Math.floor(Math.random() * 50) + 10;
      const currentAssetsCount = dataSource.assetsCount || 0;
      const updatedAssetsCount = currentAssetsCount + newAssetsCount;
      
      // Generate new assets (random or duplicate existing ones)
      const existingAssets = dataSource.sampleAssets || [];
      const newAssets: any[] = [];
      const postures = ['Acceptable', 'Risky', 'Average'];
      const owners = ['IT Admin', 'DevOps Team', 'DBA Team', 'Network Operations', 'IT Support', 'Development Team', 'IT Operations', 'HR Admin'];
      const custodians = ['DevOps Team', 'DBA Team', 'Network Admin', 'IT Admin', 'IT Support', 'HR Admin'];
      
      for (let i = 0; i < newAssetsCount; i++) {
        // Randomly decide to duplicate or create new
        const shouldDuplicate = Math.random() > 0.5 && existingAssets.length > 0;
        
        if (shouldDuplicate) {
          // Duplicate an existing asset with a new ID
          const randomAsset = existingAssets[Math.floor(Math.random() * existingAssets.length)];
          newAssets.push({
            id: `${randomAsset.id.split('-')[0]}-${String(existingAssets.length + i + 1).padStart(2, '0')}`,
            name: `${randomAsset.name} (Copy ${i + 1})`,
            type: randomAsset.type,
            owner: randomAsset.owner,
            custodian: randomAsset.custodian,
            posture: randomAsset.posture,
            date: new Date().toLocaleDateString('en-GB')
          });
        } else {
          // Create a new random asset
          const assetTypes = ['Server', 'Database', 'Network Equipment', 'People', 'Data/Info'];
          const randomType = assetTypes[Math.floor(Math.random() * assetTypes.length)];
          const randomPosture = postures[Math.floor(Math.random() * postures.length)];
          const randomOwner = owners[Math.floor(Math.random() * owners.length)];
          const randomCustodian = custodians[Math.floor(Math.random() * custodians.length)];
          
          newAssets.push({
            id: `UAM-${String(existingAssets.length + i + 1).padStart(2, '0')}`,
            name: `${randomType} ${randomType === 'Server' ? 'Prod' : randomType === 'Database' ? 'DB' : 'Device'} ${existingAssets.length + i + 1}`,
            type: randomType,
            owner: randomOwner,
            custodian: randomCustodian,
            posture: randomPosture,
            date: new Date().toLocaleDateString('en-GB')
          });
        }
      }
      
      toast.success(t('dataResource.details.toast.runSuccess', { count: newAssetsCount, name: dataSource.dataSourceName, defaultValue: `Successfully imported ${newAssetsCount} assets from ${dataSource.dataSourceName}` }));
      const updatedDataSource = {
        ...dataSource,
        lastRun: new Date().toLocaleString(),
        assetsCount: updatedAssetsCount,
        status: "Active",
        sampleAssets: [...existingAssets, ...newAssets]
      };
      setDataSource(updatedDataSource);
    } catch (error: any) {
      toast.error(error.message || t('dataResource.details.toast.runFailed', { message: error.message, defaultValue: 'Failed to run data source' }));
    }
  };

  if (loading) {
    return (
      <div style={{ paddingTop: '100px', paddingBottom: '20px' }}>
        <div className="text-center py-5">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">{t('common.loading', { defaultValue: 'Loading...' })}</span>
          </div>
        </div>
      </div>
    );
  }

  if (!dataSource) {
    return (
      <div style={{ paddingTop: '100px', paddingBottom: '20px' }}>
        <div className="container-fluid">
          <div className="alert alert-danger">
            <h4>{t('dataResource.details.notFoundTitle', { defaultValue: 'Not Found' })}</h4>
            <p>{t('dataResource.details.notFoundMessage', { defaultValue: 'Data source not found.' })}</p>
            <button className="btn btn-primary" onClick={handleBack}>
              {t('dataResource.details.back', { defaultValue: 'Back to Data Sources' })}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ paddingTop: '100px', paddingBottom: '20px', backgroundColor: '#f9fafb', minHeight: '100vh' }}>
      <div className="container-fluid p-4">
        {/* Header */}
        <div className="bg-white rounded shadow-sm border p-4 mb-4">
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-3">
              <button
                onClick={handleBack}
                className="btn btn-link text-decoration-none d-flex align-items-center gap-2 p-2"
                style={{ color: '#6b7280' }}
              >
                <FaArrowLeft />
                <span className="fw-medium">{t('dataResource.details.back', { defaultValue: 'Back' })}</span>
              </button>
              <div className="vr" style={{ height: '24px' }}></div>
              <div>
                <h1 className="h3 fw-bold mb-1">{t('dataResource.details.header', { defaultValue: 'Data Source Details' })}</h1>
                <p className="text-muted mb-0 small">{t('dataResource.details.subheader', { defaultValue: 'View and manage data source configuration' })}</p>
              </div>
            </div>
            <div className="d-flex gap-2">
              <button
                onClick={handleRun}
                className="btn btn-success d-flex align-items-center gap-2"
                style={{ backgroundColor: '#16a34a', borderColor: '#16a34a' }}
              >
                <FaPlay size={14} />
                {t('dataResource.details.runIntegration', { defaultValue: 'Run Integration' })}
              </button>
              <button
                onClick={handleEdit}
                className="btn btn-primary d-flex align-items-center gap-2"
                style={{ backgroundColor: '#2563eb', borderColor: '#2563eb' }}
              >
                <FaEdit size={14} />
                {t('dataResource.details.edit', { defaultValue: 'Edit' })}
              </button>
            </div>
          </div>
        </div>

        <div className="row g-4">
          {/* Main Content */}
          <div className="col-lg-8">
            {/* Basic Information */}
            <div className="bg-white rounded shadow-sm border p-4 mb-4">
              <h2 className="h5 fw-semibold mb-4 d-flex align-items-center gap-2">
                <div className="rounded-circle bg-primary bg-opacity-10 d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px' }}>
                  <span className="text-primary fw-semibold">1</span>
                </div>
                {t('dataResource.details.basicInformation', { defaultValue: 'Basic Information' })}
              </h2>
              
              <div className="row g-4">
                <div className="col-md-6">
                  <div className="mb-4">
                    <label className="text-dark small d-block mb-1" style={{ color: '#495057' }}>{t('dataResource.details.labels.id', { defaultValue: 'Data Source ID' })}</label>
                    <p className="h6 fw-semibold mb-0">{dataSource.id}</p>
                  </div>
                  <div className="mb-4">
                    <label className="text-dark small d-block mb-1" style={{ color: '#495057' }}>{t('dataResource.details.labels.name', { defaultValue: 'Data Source Name' })}</label>
                    <p className="h6 fw-semibold mb-0">{dataSource.dataSourceName}</p>
                  </div>
                  <div className="mb-4">
                    <label className="text-dark small d-block mb-1" style={{ color: '#495057' }}>{t('dataResource.details.labels.assetType', { defaultValue: 'Asset Type' })}</label>
                    <p className="h6 fw-semibold mb-0">{dataSource.assetType}</p>
                  </div>
                  <div className="mb-4">
                    <label className="text-dark small d-block mb-1" style={{ color: '#495057' }}>{t('dataResource.details.labels.integrationMethod', { defaultValue: 'Integration Method' })}</label>
                    <p className="h6 fw-semibold mb-0">{dataSource.integrationMethod}</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-4">
                    <label className="text-dark small d-block mb-1" style={{ color: '#495057' }}>{t('dataResource.details.labels.updateFrequency', { defaultValue: 'Update Frequency' })}</label>
                    <p className="h6 fw-semibold mb-0">{dataSource.updateFrequency}</p>
                  </div>
                  <div className="mb-4">
                    <label className="text-dark small d-block mb-1" style={{ color: '#495057' }}>{t('dataResource.details.labels.clientId', { defaultValue: 'Client ID' })}</label>
                    <p className="h6 fw-semibold mb-0">{dataSource.clientId}</p>
                  </div>
                  <div className="mb-4">
                    <label className="text-dark small d-block mb-1" style={{ color: '#495057' }}>{t('dataResource.details.labels.status', { defaultValue: 'Status' })}</label>
                    <span className={`badge px-3 py-1 ${dataSource.status === 'Active' ? 'bg-success' : 'bg-danger'}`}>
                      {dataSource.status}
                    </span>
                  </div>
                  <div className="mb-4">
                    <label className="text-dark small d-block mb-1" style={{ color: '#495057' }}>{t('dataResource.details.labels.createdAt', { defaultValue: 'Created At' })}</label>
                    <p className="h6 fw-semibold mb-0">
                      {dataSource.createdAt ? new Date(dataSource.createdAt).toLocaleDateString() : 'N/A'}
                    </p>
                  </div>
                </div>
              </div>
              
              {dataSource.description && (
                <div className="mt-4 pt-4 border-top">
                  <label className="text-dark small d-block mb-1" style={{ color: '#495057' }}>{t('dataResource.details.labels.description', { defaultValue: 'Description' })}</label>
                  <p className="mb-0 text-dark" style={{ color: '#212529' }}>{dataSource.description}</p>
                </div>
              )}
            </div>

            {/* Integration Configuration */}
            <div className="bg-white rounded shadow-sm border p-4 mb-4">
              <h2 className="h5 fw-semibold mb-4 d-flex align-items-center gap-2">
                <div className="rounded-circle bg-success bg-opacity-10 d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px' }}>
                  <span className="text-success fw-semibold">2</span>
                </div>
                {t('dataResource.details.integrationConfiguration', { defaultValue: 'Integration Configuration' })}
              </h2>

              {dataSource.integrationMethod === 'File' && (
                <div className="row g-4">
                  <div className="col-md-6">
                    <label className="text-dark small d-block mb-1" style={{ color: '#495057' }}>{t('dataResource.details.labels.filePath', { defaultValue: 'File Path' })}</label>
                    <p className="h6 fw-semibold mb-0">{dataSource.filePath || 'N/A'}</p>
                  </div>
                  <div className="col-md-6">
                    <label className="text-dark small d-block mb-1" style={{ color: '#495057' }}>{t('dataResource.details.labels.fileFormat', { defaultValue: 'File Format' })}</label>
                    <p className="h6 fw-semibold mb-0">{dataSource.fileFormat || 'N/A'}</p>
                  </div>
                </div>
              )}

              {(dataSource.integrationMethod === 'API Push' || dataSource.integrationMethod === 'API Pull') && (
                <div className="row g-4">
                  <div className="col-md-6">
                    <label className="text-dark small d-block mb-1" style={{ color: '#495057' }}>{t('dataResource.details.labels.apiEndpoint', { defaultValue: 'API Endpoint' })}</label>
                    <p className="h6 fw-semibold mb-0">{dataSource.apiEndpoint || 'N/A'}</p>
                  </div>
                  <div className="col-md-6">
                    <label className="text-dark small d-block mb-1" style={{ color: '#495057' }}>{t('dataResource.details.labels.apiMethod', { defaultValue: 'API Method' })}</label>
                    <p className="h6 fw-semibold mb-0">{dataSource.apiMethod || 'N/A'}</p>
                  </div>
                  <div className="col-md-6">
                    <label className="text-dark small d-block mb-1" style={{ color: '#495057' }}>{t('dataResource.details.labels.apiAuthentication', { defaultValue: 'Authentication' })}</label>
                    <p className="h6 fw-semibold mb-0">{dataSource.apiAuthentication || 'N/A'}</p>
                  </div>
                </div>
              )}

              {dataSource.integrationMethod === 'Database' && (
                <div className="row g-4">
                  <div className="col-md-6">
                    <label className="text-dark small d-block mb-1" style={{ color: '#495057' }}>{t('dataResource.details.labels.dbConnectionString', { defaultValue: 'Connection String' })}</label>
                    <p className="h6 fw-semibold mb-0">{dataSource.dbConnectionString || 'N/A'}</p>
                  </div>
                  <div className="col-md-6">
                    <label className="text-dark small d-block mb-1" style={{ color: '#495057' }}>{t('dataResource.details.labels.dbUsername', { defaultValue: 'Database Username' })}</label>
                    <p className="h6 fw-semibold mb-0">{dataSource.dbUsername || 'N/A'}</p>
                  </div>
                </div>
              )}

              {dataSource.integrationMethod === 'LDAP/Active Directory' && (
                <div className="row g-4">
                  <div className="col-md-6">
                    <label className="text-dark small d-block mb-1" style={{ color: '#495057' }}>{t('dataResource.details.labels.ldapServer', { defaultValue: 'LDAP Server' })}</label>
                    <p className="h6 fw-semibold mb-0">{dataSource.ldapServer || 'N/A'}</p>
                  </div>
                  <div className="col-md-6">
                    <label className="text-dark small d-block mb-1" style={{ color: '#495057' }}>{t('dataResource.details.labels.ldapPort', { defaultValue: 'LDAP Port' })}</label>
                    <p className="h6 fw-semibold mb-0">{dataSource.ldapPort || 'N/A'}</p>
                  </div>
                  <div className="col-md-6">
                    <label className="text-dark small d-block mb-1" style={{ color: '#495057' }}>{t('dataResource.details.labels.ldapBaseDN', { defaultValue: 'Base DN' })}</label>
                    <p className="h6 fw-semibold mb-0">{dataSource.ldapBaseDN || 'N/A'}</p>
                  </div>
                </div>
              )}

              {dataSource.integrationMethod === 'FTP' && (
                <div className="row g-4">
                  <div className="col-md-6">
                    <label className="text-dark small d-block mb-1" style={{ color: '#495057' }}>{t('dataResource.details.labels.ftpServer', { defaultValue: 'FTP Server' })}</label>
                    <p className="h6 fw-semibold mb-0">{dataSource.ftpServer || 'N/A'}</p>
                  </div>
                  <div className="col-md-6">
                    <label className="text-dark small d-block mb-1" style={{ color: '#495057' }}>{t('dataResource.details.labels.ftpPort', { defaultValue: 'FTP Port' })}</label>
                    <p className="h6 fw-semibold mb-0">{dataSource.ftpPort || 'N/A'}</p>
                  </div>
                </div>
              )}
            </div>

            {/* Sample Assets */}
            {dataSource.sampleAssets && dataSource.sampleAssets.length > 0 && (
              <div className="bg-white rounded shadow-sm border p-4">
                <h2 className="h5 fw-semibold mb-4 d-flex align-items-center gap-2">
                  <div className="rounded-circle bg-purple bg-opacity-10 d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px' }}>
                    <span className="text-purple fw-semibold">3</span>
                  </div>
                  {t('dataResource.details.assetsHeader', { count: dataSource.sampleAssets.length, defaultValue: `Assets (${dataSource.sampleAssets.length})` })}
                </h2>
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead className="table-light">
                      <tr>
                        <th className="text-start">{t('assets.details.id', { defaultValue: 'ID' })}</th>
                        <th className="text-start">{t('assets.create.fields.assetName', { defaultValue: 'Asset Name' })}</th>
                        <th className="text-start">{t('assets.create.fields.type', { defaultValue: 'Type' })}</th>
                        <th className="text-start">{t('assets.create.fields.owner', { defaultValue: 'Owner' })}</th>
                        <th className="text-start">{t('assets.create.fields.custodian', { defaultValue: 'Custodian' })}</th>
                        <th className="text-start">{t('assets.create.fields.posture', { defaultValue: 'Posture' })}</th>
                        <th className="text-start">{t('assets.create.fields.date', { defaultValue: 'Date' })}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dataSource.sampleAssets.map((asset: any) => (
                        <tr key={asset.id}>
                          <td className="fw-medium">{asset.id}</td>
                          <td>{asset.name}</td>
                          <td>{asset.type}</td>
                          <td>{asset.owner}</td>
                          <td>{asset.custodian}</td>
                          <td>
                            <span className={`badge ${
                              asset.posture === 'Acceptable' 
                                ? 'bg-success' 
                                : asset.posture === 'Risky'
                                ? 'bg-danger'
                                : 'bg-warning'
                            }`}>
                              {asset.posture}
                            </span>
                          </td>
                          <td>{asset.date}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>

          {/* Sidebar */}
          <div className="col-lg-4">
            <div className="bg-white rounded shadow-sm border p-4">
              <h3 className="h5 fw-semibold mb-4">{t('dataResource.details.sidebar.currentStatus', { defaultValue: 'Status Overview' })}</h3>
              <div className="d-flex flex-column gap-3">
                <div className="d-flex justify-content-between align-items-center">
                  <span className="text-dark small" style={{ color: '#495057' }}>{t('dataResource.details.sidebar.lastRun', { defaultValue: 'Last Run' })}</span>
                  <span className="fw-medium">{dataSource.lastRun || 'N/A'}</span>
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <span className="text-dark small" style={{ color: '#495057' }}>{t('dataResource.details.sidebar.assetsCount', { defaultValue: 'Assets Count' })}</span>
                  <span className="fw-medium">{dataSource.assetsCount || 0}</span>
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <span className="text-dark small" style={{ color: '#495057' }}>{t('dataResource.details.labels.status', { defaultValue: 'Status' })}</span>
                  <span className={`badge ${dataSource.status === 'Active' ? 'bg-success' : 'bg-danger'}`}>
                    {dataSource.status || 'Inactive'}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataSourceDetails;
